// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".success[data-v-f45df9b4]{color:var(--g-color-success);font-weight:700}.error[data-v-f45df9b4]{color:var(--g-color-error);font-weight:700}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
